import {fetchJSON, fetchPOST, fetchTEXT} from '../Tools';

interface IWarningItem {
    element: HTMLElement;
    label: HTMLElement;
}

interface IWarningData {
    id: string;
    threshold: number;
    title: string;
    description: string;
}
interface IDetailWarning {
    container: HTMLElement;
    outerWidth: number;
    // items: NodeListOf<HTMLElement>;
    items: Array<IWarningItem>;
    Abfluss: number;
    Wasserstand: number;
    Warn1: number;
    Warn2: number;
    WarnMax: number;
    selector: HTMLElement;
}

export default class DetailWarn {
    protected dialog: JQuery<HTMLElement>;
    protected template: HTMLTemplateElement;
    protected editContainer: NodeListOf<HTMLElement>;
    protected container: HTMLElement;
    protected fkId = '';
    protected stationType = '';
    protected warnMax: HTMLInputElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.warnMax = <HTMLInputElement>this.container.querySelector('input[name="warnmax"]');
        if (this.container.querySelector('.pegel-dropdown')) {
            this.initStationSelector();
        }
        this.container.querySelectorAll('.pegel-detail-warn').forEach((container: HTMLElement) => {
            const labels = <NodeListOf<HTMLElement>>container.querySelectorAll('.pegel-detail-labels .pegel-detail-label');
            const items = [];
            container.querySelectorAll('.pegel-detail-item ').forEach((el: HTMLElement, index) => {
                const warningItem: IWarningItem = {
                    element: el,
                    label: labels[index],
                };
                items.push(warningItem);
            });

            const warningItem: IDetailWarning = {
                container: container,
                outerWidth: container.getBoundingClientRect().width,
                items: items,
                Abfluss: parseFloat(container.dataset.abfluss),
                Wasserstand: parseFloat(container.dataset.wasserstand),
                Warn1: parseFloat(container.dataset.warn1),
                Warn2: parseFloat(container.dataset.warn2),
                WarnMax: parseFloat(container.dataset.warnmax),
                selector: container.querySelector('.pegel-current'),
            };

            if (warningItem.Warn1 + warningItem.Warn2 >= warningItem.WarnMax) {
                warningItem.WarnMax = warningItem.Warn1 + warningItem.Warn2 + (warningItem.Warn1 + warningItem.Warn2) * 0.2;
            }
            // 88.40 * (66 / 12.29 ) = 474,72742066720911310008136696501
            const wasserStand1 = Math.ceil(warningItem.Wasserstand * (warningItem.Warn1 / warningItem.Abfluss));
            const wasserStand2 = Math.ceil(warningItem.Wasserstand * (warningItem.Warn2 / warningItem.Abfluss));
            const wasserstandLabels: NodeListOf<HTMLElement> = warningItem.container.querySelectorAll('.pegel-detail-wasser-labels .pegel-detail-label');
            if (isNaN(parseFloat(wasserstandLabels[1].textContent))) {
                wasserstandLabels[1].textContent = wasserStand1 + '';
            }
            if (isNaN(parseFloat(wasserstandLabels[2].textContent))) {
                wasserstandLabels[2].textContent = wasserStand2 + '';
            }

            const col1Width = (warningItem.Warn1 / warningItem.WarnMax) * 100;
            const col2Width = (warningItem.Warn2 / warningItem.WarnMax) * 100;
            const col3Width = 100 - col1Width - col2Width;
            if (!Number.isNaN(col1Width)) {
                warningItem.items[0].element.style.width = col1Width + '%';
                warningItem.items[0].label.style.left = '0';
                warningItem.items[1].element.style.width = col2Width + '%';
                warningItem.items[1].label.textContent = warningItem.Warn1 + '';
                warningItem.items[1].label.style.left = 'calc(' + col1Width + '% - ' + warningItem.items[1].label.getBoundingClientRect().width / 2 + 'px)';
                wasserstandLabels[1].style.left = 'calc(' + col1Width + '% - ' + wasserstandLabels[1].getBoundingClientRect().width / 2 + 'px)';

                warningItem.items[2].element.style.width = col3Width + '%';
                warningItem.items[2].label.textContent = warningItem.Warn2 + '';
                warningItem.items[2].label.style.left = 'calc(' + (col1Width + col2Width) + '% - ' + warningItem.items[2].label.getBoundingClientRect().width / 2 + 'px)';
                wasserstandLabels[2].style.left = 'calc(' + (col1Width + col2Width) + '% - ' + wasserstandLabels[2].getBoundingClientRect().width / 2 + 'px)';
            } else {
                wasserstandLabels[1].style.left = '32%';
                wasserstandLabels[2].style.left = '65%';
                warningItem.items[1].label.style.left = '32%';
                warningItem.items[2].label.style.left = '65%';
            }

            const currentLeft = (warningItem.Abfluss / warningItem.WarnMax) * 100;
            if (currentLeft >= 97.6) {
                warningItem.selector.style.right = '3px';
            } else {
                warningItem.selector.style.left = currentLeft + '%';
            }
            warningItem.selector.title = 'Abfluss ' + warningItem.Abfluss + ' m³/s<br /';
            if (warningItem.selector.classList.contains('trend-down')) {
                warningItem.selector.title += 'Tendenz fallend';
            }
            if (warningItem.selector.classList.contains('trend-up')) {
                warningItem.selector.title += 'Tendenz steigend';
            }
            if (warningItem.selector.classList.contains('trend-flat')) {
                warningItem.selector.title += 'Tendenz gleichbleibend';
            }
            warningItem.container.querySelector('.pegel-detail-loader').classList.remove('show');
            warningItem.container.querySelector('.pegel-detail-loader').classList.add('d-none');
        });

        if (container.nextElementSibling?.classList.contains('js-talsperre-info-control')) {
            container.querySelector('.container-fluid.block')?.classList.add('low-distance');
        }
    }

    initStationSelector() {
        this.container.querySelector('.pegel-dropdown').addEventListener('PegelSelect:change', (ev: CustomEvent) => {
            const option = <HTMLOptionElement>ev.detail.jqItem.item.element.context;
            const warnTextFields: NodeListOf<HTMLElement> = this.container.querySelectorAll('.js-pegel-warn');
            const infoContainer = <HTMLElement>this.container.querySelector('.js-warn-container');
            infoContainer.dataset.fkid = option.dataset.id;
            infoContainer.dataset.type = option.dataset.type;
            this.fkId = option.dataset.fkid;
            this.stationType = infoContainer.dataset.type;
            const span = document.createElement('span');
            span.classList.add('warning-empty','icon-exclamation','alert','alert-danger');
            span.title = 'Warnwert 1 nicht gesetzt';
            warnTextFields[0].innerHTML = '';
            warnTextFields[1].innerHTML = '';
            if (option.dataset.warn1 === '') {
                warnTextFields[0].insertAdjacentElement('afterbegin',span);
            } else {
                warnTextFields[0].innerText = option.dataset.warn1;
            }
            if (option.dataset.warn1 === '') {
                const span2 = <HTMLSpanElement>span.cloneNode(true);
                span2.title = 'Warnwert 2 nicht gesetzt';
                warnTextFields[1].insertAdjacentElement('afterbegin', span2);
            } else {
                warnTextFields[1].innerText = option.dataset.warn1;
            }

            warnTextFields[2].innerText =
                parseFloat(option.dataset.warn1) + parseFloat(option.dataset.warn2) + (parseFloat(option.dataset.warn1) + parseFloat(option.dataset.warn2)) * 0.2 + '';

            if (this.warnMax.value === '') {
                this.warnMax.value = warnTextFields[2].innerText;
            }
            const wasserStand = fetchTEXT('/Handler/Parameter/Wasserstand?&active=1&pid=' + option.dataset.id + '&_=' + Date.now());
            wasserStand.then((value) => {
                (<HTMLElement>this.container.querySelector('.js-wasserstand-now')).innerText = value;
            });
        });
        this.container.querySelectorAll('.js-station-type-selector').forEach((typeSelectorContainer: HTMLElement) => {
            const stationSelectors = typeSelectorContainer.querySelectorAll('.js-station-selector');

            typeSelectorContainer.querySelectorAll('.js-type-selector input[type="radio"]').forEach((typeRadio: HTMLInputElement) => {
                typeRadio.addEventListener('change', () => {
                    stationSelectors.forEach((el) => {
                        el.classList.add('d-none');
                        typeRadio.dataset.name = '';
                        if (typeRadio.checked && el.classList.contains('type-' + typeRadio.value)) {
                            el.classList.remove('d-none');
                            typeRadio.dataset.name = 'stationType';
                            this.stationType = typeRadio.value;
                        }
                    });
                });
                if (typeRadio.checked) {
                    typeRadio.dispatchEvent(new Event('change'));
                }
            });
        });
        this.editContainer = this.container.querySelectorAll('.js-warn-container');

        this.editContainer.forEach((container) => {
            this.initDialog(container);
        });
    }

    initDialog(container: HTMLElement) {
        let dialog = $(container.querySelector('.js-detail-warn-dialog')).dialog({
            autoOpen: false,
            modal: true,
            width: 540,
            title: 'Detailwarnung',
            height: 540,
            maxHeight: 540,
        });
        container.querySelector('.js-edit-detail-warnings').addEventListener('click', (ev) => {
            this.fkId = container.dataset.fkid;
            this.stationType = container.dataset.type;
            this.getWarningData(container, dialog);
        });
        dialog.find('.js-add-entry')[0].addEventListener('click', (ev) => {
            const entry = this.addTemplateItem(dialog);
            (<HTMLInputElement>entry.querySelector('[name="threshold"')).focus();
        });
        dialog.find('.js-btn-save')[0].addEventListener('click', (ev) => {
            this.updateWarningData(dialog);
        });
    }

    async getWarningData(container: HTMLElement, dialog) {
        dialog.context.querySelector('.dlg-body').innerHTML = '';
        this.template = <HTMLTemplateElement>container.querySelector('.js-tmpl-warning-display');
        /** @var {Array<IWarningData>} */
        const displayItems = await fetchJSON('/?ajax=DetailWarning&id=' + this.fkId + '-' + this.stationType);
        if (displayItems.length) {
            displayItems.forEach((element) => {
                this.addTemplateItem(dialog, element);
            });
        }
        dialog.show();
        dialog.dialog('open');
    }

    async updateWarningData(dialog) {
        let itemData: Array<IWarningData> = [];
        (<NodeListOf<HTMLElement>>dialog.context.querySelectorAll('.js-template-body')).forEach((body) => {
            let item: IWarningData = {
                id: (<HTMLElement>body).dataset.id,
                threshold: parseFloat((<HTMLInputElement>body.querySelector('[name="threshold"')).value),
                title: (<HTMLInputElement>body.querySelector('input[name="title"')).value,
                description: (<HTMLElement>body.querySelector('.ckedit')).innerHTML,
            };
            itemData.push(item);
        });
        const result = await fetchPOST('/?ajax=DetailWarning&action=update&id=' + this.fkId + '-' + this.stationType, {id: this.fkId, data: JSON.stringify(itemData)}, false);
        if (result === 'OK') {
            window.tools.toast('Detailwarnung', 'Daten gespeichert');
            dialog.dialog('close');
        } else {
            window.tools.toast('Detailwarnung', 'Beim speichern ist ein Fehler aufgetreten');
        }
    }

    addTemplateItem(dialog, warningItemData: IWarningData = null) {
        let clone = (<HTMLElement>this.template.content.cloneNode(true)).querySelector('.js-template-body');
        const editor = clone.querySelector('.ckedit');
        if (warningItemData) {
            (<HTMLElement>clone).dataset.id = warningItemData.id;
            (<HTMLInputElement>clone.querySelector('[name="threshold"')).value = warningItemData.threshold + '';
            (<HTMLInputElement>clone.querySelector('input[name="title"')).value = warningItemData.title;
            (<HTMLElement>clone.querySelector('.ckedit')).innerHTML = warningItemData.description;
            const deleteButton = <HTMLElement>clone.querySelector('.js-delete');
            deleteButton.dataset.uid = warningItemData.id;
            deleteButton.addEventListener('click', async () => {
                if (confirm('Sicher das Sie den Eintrag löschen möchten?')) {
                    const result = await fetchPOST('/?ajax=DetailWarning', {
                        id: deleteButton.dataset.uid,
                        action: 'delete',
                    });
                    if (parseInt(result) === 1) {
                        clone.remove();
                    }
                }
            });
            editor.id = 'warn-editor-' + warningItemData.id;
        } else {
            (<HTMLElement>clone).dataset.id = 'new';
            editor.id = 'warn-editor-new-' + Date.now();
        }
        dialog.context.querySelector('.dlg-body').insertAdjacentElement('beforeend', clone);
        window.CKEDITOR.inline(editor.id);
        return clone;
    }
}
